/** Posts the current content height to the parent window so it can resize the iframe. */
export const reportHeight = () => {
    if (window.parent == window) {
        return;
    }

    const cookieBannerElement = document.getElementById('ps-cookie-banner');
    const cookieBannerHeight = cookieBannerElement?.children[0]?.children[0]?.clientHeight
        ? cookieBannerElement.children[0].children[0].clientHeight + 20
        : 0;
    const bodyHeight = document.body.clientHeight;

    window.parent.postMessage(
        { height: bodyHeight < cookieBannerHeight ? cookieBannerHeight : bodyHeight },
        '*',
    );
};

/** Sets up ResizeObserver and MutationObserver to continuously report height changes via {@link reportHeight}. Call once on mount. */
export const initEmbedHeightObserver = () => {
    if (window.parent == window) {
        return;
    }

    const cookieOverlayWrapper = document.getElementById('ps-cookie-banner-wrapper');

    const mutationObserver = new MutationObserver(reportHeight);
    const resizeObserver = new ResizeObserver(reportHeight);

    resizeObserver.observe(document.body);

    if (cookieOverlayWrapper) {
        mutationObserver.observe(cookieOverlayWrapper, { childList: true });
    }
};
